<div class="modal-header border-0">
    <button type="button" class="close-x mt-1 me-1" aria-label="Close" (click)="activeModal.dismiss()" style="background-color: #D5D9EB;">
        <i class="fa-light fa-xmark"></i>
    </button>
</div>
<div class="modal-body text-center">
    <img [src]="cdnUrl + '/Lightstone.Design/v1/images/bg-whatsapp.png'" style="width:171px; height:127px;">
    <h3 class="modal-heading text-primary fw-semibold">Share report on WhatsApp</h3>
    <p class="text-primary">
        Your PDF is ready to share. Send it instantly on WhatsApp or download it to share later.
    </p>
    <p class="mb-0 modal-text text-truncate text-black px-5"><i class="fa-light fa-file-pdf me-1 text-primary"></i> {{ file?.name?.toLowerCase() }}</p>

    <div class="row mt-4">
        <div class="col"><button type="button" class="btn btn-outline-primary w-100" (click)="download()">Download</button></div>
        <div class="col"><button type="button" class="btn btn-primary w-100" (click)="share()">
                Share to WhatsApp
            </button></div>

    </div>

</div>